import React, { FunctionComponent } from "react";

import { Card, ICardProps } from "@/components/Card";

interface IStyledDetailCardProps extends ICardProps {
  className?: string;
}

export const StyledDetailCard: FunctionComponent<IStyledDetailCardProps> = ({ children, className, ...cardProps }) => (
  <Card className={className} {...cardProps}>
    {children}
  </Card>
);
